const AUTH_STORAGE_KEYS = [
  'user_authToken',
  'user_id',
  'user_name',
  'user_fullName',
  'user_role_id',
  'user_role',
  'user_username',
];

export const clearAuthStorage = () => {
  AUTH_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
};

export const redirectToLogin = () => {
  clearAuthStorage();
  window.location.hash = '#/login';
  window.location.reload();
};
